module.exports = __webpack_public_path__ + "static/media/dancing-icon.5cfff4b6.png";